import {Component, Input, OnInit} from "@angular/core";
import { IrbSettingsService } from '@irb/irb-settings/irb-settings.service';
import {faDownload} from '@fortawesome/free-solid-svg-icons';
import { IrbAgGridExportService } from "@irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-grid-export/irb-ag-grid-export.service";

@Component({
  selector: 'irb-settings-history',
  templateUrl: './settings-history.component.html',
  styleUrl: './settings-history.component.scss',
  standalone: false
})
export class SettingsHistoryComponent implements OnInit {
  isUiTest = false;
  gridOptions: any;
  grid: any;
  hasServerSideDatasource: boolean = false;
  faDownload = faDownload;
  @Input() portfolioId: any;
  @Input() tabName: string = '';
  totalRecordsFromServer: number;
  currentHistoryDisplayed: number;
  footerContent: string;

  constructor(private iss: IrbSettingsService, public ges: IrbAgGridExportService) {
  }

  ngOnInit() {
    const colDef: any = this.getSecColumnDefs();
    
    this.gridOptions = {
      sortModel: [
        {colId: 'createdDate', sort: 'desc'}
      ],
      columnDefs: colDef,
      rowModelType: 'serverSide',
      floatingFilter: false,
      overlayLoadingTemplate: "<div class='loading-spinner'></div>",
      overlayNoRowsTemplate: "No results found.",
      context: {componentParent: this},
      onSortChanged: () => {
        if (!this.hasServerSideDatasource) {
          this.grid.api.setGridOption('serverSideDatasource', this.setDatasource());
        }
      }
    };
  }

  private getSecColumnDefs() {
    return [
      {
        headerName: "Timestamp",
        field: "createdDate",
        cellRenderer: 'cellRendererFormatter',
        cellRendererParams: {type: 'date', format: 'MM/dd/yyyy h:mm a', displayETtext: true},
        minWidth: 150,
        suppressMovable: true
      },
      {
        headerName: "User",
        field: "createdBy",
        minWidth: 70,
        cellRenderer: 'cellRendererFormatter',
        suppressMovable: true
      },
      {
        headerName: "Attribute",
        field: "attributeName",
        minWidth: 50,
        cellRenderer: 'cellRendererFormatter',
        suppressMovable: true
      },
      {
        headerName: "Previous Value",
        field: "previousValue",
        minWidth: 70,
        suppressMovable: true,
        valueFormatter: (params: any) => {
          return params.value ? params.value : '-';
        }
      },
      {
        headerName: "Updated Value",
        field: "updatedValue",
        suppressMovable: true,
        valueFormatter: (params: any) => {
          return params.value ? params.value : '-';
        }
      }
    ];
  }

  onGridReady(params: any) {
    this.grid = params;

    if (!this.hasServerSideDatasource) {
      this.grid.api.setGridOption('serverSideDatasource', this.setDatasource());
    }
  }

  setDatasource() {
    this.hasServerSideDatasource = true;
    return {
      getRows: (params: any) => {
        this.grid.api.showLoadingOverlay();
        this.iss.getSettingsHistory(params, this.tabName).subscribe({next: (data: any) => {
          const gridData: any[] = data.body ?? data;
          this.getCurrentHistoryCount(data.headers);

          if (gridData.length === 0) {
            this.grid.api.showNoRowsOverlay();
          } else {
            this.grid.api.hideOverlay();
          }

          params.success({rowData: gridData, rowCount: this.totalRecordsFromServer});
        }, error: () => {
          this.grid.api.hideOverlay();
          this.grid.api.showNoRowsOverlay();
        }});
      }
    }
  }

  private getCurrentHistoryCount(headers: any) {
    const filterCount = headers?.get('Filter-Count');
    const lengthOfContentRange = filterCount ? filterCount.trim().length : 0;
    const indexOfSlash = filterCount ? filterCount.toString().indexOf('/') : 0;
    this.currentHistoryDisplayed = filterCount
      ? parseInt(filterCount.toString().substring(indexOfSlash + 1, lengthOfContentRange))
      : 0;
    this.totalRecordsFromServer = this.currentHistoryDisplayed;
    this.footerContent = this.currentHistoryDisplayed + ' records displayed';
  }
  
  exportHistory() {
    this.iss.exportSettingsHistory(this.tabName).subscribe((_res: any) => {
      this.ges.showSuccessMessage();
    });
  }
}
